function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.745 21.022c0-.644.574-1.166 1.281-1.166.708 0 1.282.522 1.282 1.166 0 .644-.574 1.167-1.282 1.167-.707 0-1.281-.523-1.281-1.167z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 28c1.011-3.011 3.034-9.433 3.034-9.433a10.824 10.824 0 013.293-2.463l2.194 2.952.037.038a.194.194 0 00.237.002.199.199 0 00.04-.277l-2.144-2.883a10.64 10.64 0 011.61-.556h5.364c.578.15 1.138.346 1.675.585l-2.122 2.854-.025.046a.199.199 0 00.064.23c.087.066.21.048.274-.039l2.172-2.92a10.827 10.827 0 013.228 2.431S25.977 24.977 27 28H5zm13.195-6.101c.1 0 .18-.074.18-.164v-.575c0-1.19-1.02-2.187-2.277-2.222a2.465 2.465 0 00-1.708.603c-.459.406-.712.952-.712 1.535 0 .997.774 1.875 1.842 2.09.21.041.369.208.397.413l.292 2.125a.16.16 0 00.086.12l1.807.987c.056.03.124.032.182.003a.164.164 0 00.09-.144v-3.948c0-.09-.08-.165-.18-.165h-.542v-.658h.543z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.537 10.615c0 .387-.116.745-.329 1.033 0 0-1.378 1.502-1.44 1.56-.35.312-.74.46-1.165.46h-1.22c-.425 0-.816-.148-1.166-.46-.062-.058-1.44-1.56-1.44-1.56a1.725 1.725 0 01-.329-1.033v-3.04C12.448 5.602 14.035 4 15.993 4c1.957 0 3.544 1.601 3.544 3.576v3.04z",
  fill: "currentColor"
})));